<template>
    <div class="all addDate">
        <div class="warp mt20">
            <div class="warp-header d-flex justify-between">
                <h2>数据补录</h2>
                <div class="addData cup" @click="addData">新增</div>
            </div>
            <div class="warp-body clearfix minheight">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="70%">
                        <col width="15%">
                        <col width="15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>文章链接</th>
                            <th>添加时间</th>
                            <th>状态</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in dataList" :key="index">
                            <td>
                                <div class="ovhidden" style="width: 100%;">{{item.sourceUrl}}</div>
                            </td>
                            <td>{{item.addtime}}</td>
                            <td>
                                <div class="table-all-icons">
                                    <span v-if="item.status == '0'" class="status1">{{item.statusText}}</span>
                                    <span v-else-if="item.status =='1'" class="status2">{{item.statusText}}</span>
                                    <span v-else class="status3">{{item.statusText}}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- 补录数据 -->
        <Dialog ref="addDataModal" type="normal" width="776" title="新增补录" :callback="sureAdd">
            <div slot="mdBox" class="d-flex">
                <div class="title__">原文链接:</div>
                <el-input v-model="url" placeholder="请输入补录的链接"></el-input>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import vipMenu from './vipMenu.vue';
export default {
    components:{Dialog,vipMenu},
    data() {
        return {
            dataList:[],
            url:''
        }
    },
    mounted() {
        this.getdataList();
    },
    created() {
		
    },
    methods: {
        //
        addData(){
            this.$refs.addDataModal.showMaskFun();  
        },
        // 获取设置显示
        getdataList (){
            let that = this;
            that.$api.get('user/supplement/list',null,r =>{
                that.$parent.returnCode(r,function(){
                    that.dataList = r.data.list;
                })
            })
        },
        //确认添加
        sureAdd(){
            let that = this;
            console.log(this.url.indexOf('http'))
            if(this.url.indexOf('http')<0){
                that.$utils.alertText('请输入合法的链接');
                return false;
            }
            that.$parent.loadModal(true,'正在补录中。。。');
            that.$api.post('user/supplement/add',{url:this.url},r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.$utils.alertText('已提交，待审核');
                    that.url = '';
                    that.getdataList();
                })
            })
        }
	}
}
</script>
<style scope>
    
</style>



// WEBPACK FOOTER //
// src/page/personalCenter/addData.vue